import React, { useEffect, useRef } from "react";

/** CCTV */
const RTSPPlayer = (props) => {
  const { object } = props;

  const CCTV_URL = object.cctv_url;
  const width = object.width + "px";
  const height = object.height * 0.8 + "px";
  const videoRef = useRef(null);

  useEffect(() => {
    let player = videoRef.current;

    // 비디오 플레이어가 준비되었을 때 실행되는 이벤트 리스너 추가
    player.addEventListener("canplay", () => {
      player.play();
    });

    // 브라우저가 RTSP 프로토콜을 지원하는지 확인합니다.
    if (player.canPlayType("application/x-rtsp")) {
      player.src = CCTV_URL;
    } else {
      // RTSP가 지원되지 않을 경우 에러 메시지를 플레이어에 표시합니다.
      const error = document.createTextNode(
        "이 브라우저에서는 RTSP 비디오 스트리밍을 지원하지 않습니다."
      );
      player.appendChild(error);
    }

    return () => {
      // 컴포넌트가 언마운트될 때 이벤트 리스너 정리
      player.removeEventListener("canplay", () => {
        player.play();
      });
    };
  }, [CCTV_URL]);

  return <video ref={videoRef} autoPlay muted controls />;
};

export default RTSPPlayer;
